import { useStore } from 'dg-web-shared/lib/Flux';
import * as LayoutState from '../state/LayoutState';
import { LogoSloganVariant } from '../utils/LogoSloganVariant';
import { columnsVariant } from '../utils/columnsVariant';
import { responsiveVariant } from '../utils/responsiveVariant';
import { clearfix } from 'dg-web-shared/ui/clearfix';
import { css } from '@emotion/css';
import { LayoutVariantOption } from './LayoutContainer';

export interface ColumnContainerProps {
    children?: React.ReactNode;
    relative?: boolean;
    layoutVariant: LayoutVariantOption;
}
export interface ColumnContainerState {
    layout: LayoutState.State;
}

export function ColumnContainer({
    children,
    relative,
    layoutVariant,
}: ColumnContainerProps) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    const logoSloganVariant = new LogoSloganVariant(storeState, layoutVariant);
    return (
        <div className={clearfix}>
            <div
                className={css([
                    {
                        clear: 'left',
                        bottom: '40px',
                        left: 0,
                        right: 0,
                        position: 'absolute',
                    },
                    relative && {
                        position: 'relative',
                    },
                    columnsVariant(storeState) === 'ThreeColumns' && [
                        logoSloganVariant.toString() === 'Large' && {
                            top: '128px',
                        },
                        logoSloganVariant.toString() === 'Medium' && {
                            top: '104px',
                        },
                        logoSloganVariant.toString() === 'Small' && {
                            top: '80px',
                        },
                    ],
                    columnsVariant(storeState) === 'OneColumn' && [
                        {
                            top: 0,
                            bottom: 0,
                        },
                        layoutVariant === LayoutVariantOption.StaticPage && [
                            { paddingTop: '40px', marginTop: '16px' },
                            responsiveVariant(storeState) === 'Mobile' && {
                                paddingTop: 0,
                            },
                        ],
                    ],
                ])}
            >
                {children}
            </div>
        </div>
    );
}
